<template>
  <div>
    <!--   Como muitas vezes o objeto vem, mas vem vazio, vasmo testar pra isso. -->
    <div v-if="lastChallenge">
      <div class="m-5 ">
        <router-link :to="'/desafio'">
          <LastChallengeCard
            :challenge="lastChallenge"
            :isLastChallenge="true"
            :status="lastChallengeStatus"
          />
        </router-link>
      </div>
      <div class="text-center">
        <ChallengeGeneratorButton />
      </div>
    </div>

    <div v-if="this.challenges.length != 0">
      <hr class="my-4" />

      <h1 class="">
        Últimos Desafios
      </h1>

      <div class="m-5" v-for="challenge in challenges" :key="challenge.id">
        <router-link
          :to="`/desafio/${challenge.id}`"
          v-if="challenge.id !== lastChallenge.id"
        >
          <PreviousChallengeCard :challenge="challenge" />
          <!-- <ChallengeCard :challenge="challenge" /> -->
        </router-link>
      </div>
    </div>

    <div v-else><NoChallengesYet /></div>
    <!-- <ChallengeGeneratorButton /> -->
  </div>
</template>

<script>
import ChallengeGeneratorButton from "./ChallengeGeneratorButton";
import LastChallengeCard from "./LastChallengeCard";
import PreviousChallengeCard from "./PreviousChallengeCard";
import NoChallengesYet from "./NoChallengesYet";

export default {
  name: "Challenges",
  data() {
    return {};
  },
  computed: {
    challenges: function() {
      return this.$store.state.challenges;
    },
    lastChallenge: function() {
      return this.$store.state.lastChallenge;
    },
    lastChallengeStatus: function() {
      let status = "new";
      if (this.lastChallenge.started_at) {
        status = "started";
      }
      if (this.lastChallenge.completed_at) {
        status = "completed";
      }
      return status;
    }
  },
  components: {
    LastChallengeCard,
    ChallengeGeneratorButton,
    PreviousChallengeCard,
    NoChallengesYet
  },

  created() {
    this.$store.dispatch("fetchChallenges");
    this.$store.dispatch("fetchLastChallenge");
  },
  mounted() {
    // vamos evitar que usuário entre em challenges antigos e tenha alguns segundos com outro challenge.
    this.$store.dispatch("cleanSelectedChallenge");
  }
};
</script>
<style></style>
